(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-product"] && !Shopify.designMode) return;
  try {
    
  class FaqProductTabs extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.questions = this.querySelectorAll('.faq-product__question');
      this.init();
    }

    init() {
      this.questions.forEach((question) => {
        question.addEventListener('click', () => this.handleQuestionClick(question));
      });

      const firstQuestion = this.querySelector('.faq-product__question');
      if (firstQuestion) {
        this.openQuestion(firstQuestion);
      }
    }

    handleQuestionClick(clickedQuestion) {
      const item = clickedQuestion.closest('.faq-product__item');
      const answer = item.querySelector('.faq-product__answer');
      const isExpanded = clickedQuestion.getAttribute('aria-expanded') === 'true';

      if (isExpanded) {
        this.closeQuestion(clickedQuestion);
      } else {
        this.questions.forEach((question) => {
          if (question !== clickedQuestion) {
            this.closeQuestion(question);
          }
        });
        this.openQuestion(clickedQuestion);
      }
    }

    openQuestion(question) {
      const item = question.closest('.faq-product__item');
      const answer = item.querySelector('.faq-product__answer');

      question.setAttribute('aria-expanded', 'true');
      answer.style.maxHeight = answer.scrollHeight + 'px';
      item.classList.add('faq-product__item--open');
    }

    closeQuestion(question) {
      const item = question.closest('.faq-product__item');
      const answer = item.querySelector('.faq-product__answer');

      question.setAttribute('aria-expanded', 'false');
      answer.style.maxHeight = '0';
      item.classList.remove('faq-product__item--open');
    }
  }

  customElements.define('faq-product-tabs', FaqProductTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  class FaqTabs extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.tabs = this.querySelectorAll('.faq__tab');
      this.dropdownOptions = this.querySelectorAll('.faq__dropdown-option');
      this.panels = this.querySelectorAll('.faq__panel');
      this.dropdownText = this.querySelector('.faq__dropdown-text');
      this.dropdown = this.querySelector('.faq__dropdown');
      this.init();
    }

    init() {
      // Desktop tabs
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', (e) => this.handleTabClick(e));
      });

      // Mobile dropdown options
      this.dropdownOptions.forEach((option) => {
        option.addEventListener('click', (e) => this.handleDropdownClick(e));
      });

      // Initialize accordion functionality only once for all panels
      this.initAccordion();
    }

    handleTabClick(e) {
      const clickedTab = e.currentTarget;
      const categoryId = clickedTab.dataset.category;

      // Update active tab
      this.tabs.forEach((tab) => tab.classList.remove('faq__tab--active'));
      clickedTab.classList.add('faq__tab--active');

      this.switchCategory(categoryId);
    }

    handleDropdownClick(e) {
      const clickedOption = e.currentTarget;
      const categoryId = clickedOption.dataset.category;

      // Update active dropdown option
      this.dropdownOptions.forEach((option) => option.classList.remove('faq__dropdown-option--active'));
      clickedOption.classList.add('faq__dropdown-option--active');

      // Update dropdown text
      if (this.dropdownText) {
        this.dropdownText.textContent = clickedOption.textContent;
      }

      // Close dropdown
      if (this.dropdown) {
        this.dropdown.removeAttribute('open');
      }

      this.switchCategory(categoryId);
    }

    switchCategory(categoryId) {
      // First, remove active class from ALL panels
      this.panels.forEach((panel) => {
        panel.classList.remove('faq__panel--active');
      });

      // Then, add active class only to the target panel
      this.panels.forEach((panel) => {
        if (panel.dataset.category === categoryId) {
          panel.classList.add('faq__panel--active');
        }
      });
    }

    initAccordion() {
      // Get all questions from all panels
      const allQuestions = document.querySelectorAll('.faq__question');

      allQuestions.forEach((question) => {
        question.addEventListener('click', () => {
          const item = question.closest('.faq__item');
          const panel = question.closest('.faq__panel');
          const answer = item.querySelector('.faq__answer');
          const isExpanded = question.getAttribute('aria-expanded') === 'true';

          if (isExpanded) {
            // Close
            question.setAttribute('aria-expanded', 'false');
            answer.style.maxHeight = '0';
            item.classList.remove('faq__item--open');
          } else {
            // Close all other items in the same panel only
            const panelQuestions = panel.querySelectorAll('.faq__question');
            panelQuestions.forEach((otherQuestion) => {
              if (otherQuestion !== question) {
                const otherItem = otherQuestion.closest('.faq__item');
                const otherAnswer = otherItem.querySelector('.faq__answer');

                otherQuestion.setAttribute('aria-expanded', 'false');
                otherAnswer.style.maxHeight = '0';
                otherItem.classList.remove('faq__item--open');
              }
            });

            // Open current
            question.setAttribute('aria-expanded', 'true');
            answer.style.maxHeight = answer.scrollHeight + 'px';
            item.classList.add('faq__item--open');
          }
        });
      });

      // Open first question of the first active panel by default
      const activePanel = document.querySelector('.faq__panel--active');
      if (activePanel) {
        const firstQuestion = activePanel.querySelector('.faq__question');
        if (firstQuestion) {
          firstQuestion.click();
        }
      }
    }
  }

  customElements.define('faq-tabs', FaqTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grid-cards"] && !Shopify.designMode) return;
  try {
    
  class GridCardsModal extends HTMLElement {
    constructor() {
      super();
      this.modal = this;
      this.trigger = document.querySelector(`[data-modal-trigger="${this.id}"]`);
      this.closeElements = this.querySelectorAll('[data-modal-close]');

      this.init();
    }

    init() {
      if (this.trigger) {
        this.trigger.addEventListener('click', () => this.openModal());
      }

      this.closeElements.forEach((element) => {
        element.addEventListener('click', () => this.closeModal());
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.getAttribute('aria-hidden') === 'false') {
          this.closeModal();
        }
      });
    }

    openModal() {
      this.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    closeModal() {
      this.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  }

  customElements.define('grid-cards-modal', GridCardsModal);

  document.querySelectorAll('.grid-cards__title-link').forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const popupButton = document.querySelector('.product-popup-modal__button.link');
      if (popupButton) {
        popupButton.click();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
